import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../../common/icon/icon.component.jsx";
import { FormattedDate, FormattedMessage, injectIntl } from "react-intl";
import { SingleDatePicker } from "react-dates"
import moment from "moment"
import EndingTypeLabel from "./endingtypelabel.component.jsx";
import { isInclusivelyAfterDay } from 'react-dates';
import LabelHelper from "../../common/LabelHelper.jsx";
const uuidv4 = require('uuid/v4')


class RecurringInvoiceSchedule extends Component {

    constructor(props, context) {
        super(props, context)
        const info = this.props.value || {}
        const attr = info.attributes || {}
        this.state = {
            info: info,
            startDate: attr.startDate ? moment(attr.startDate) : '',
            endDate: attr.endDate ? moment(attr.endDate) : '',
            occurrencesCount: attr.occurrencesCount || 0,
            endingType: attr.endingType || 'never',
            invoiceId: this.props.invoiceId || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            endDateFocused: false,
            startDateFocused: false,

        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        const info = nextProps.value || {}
        const attr = info.attributes || {}
        this.setState({
            info: info,
            startDate: attr.startDate ? moment(attr.startDate) : '',
            endDate: attr.endDate ? moment(attr.endDate) : '',
            occurrencesCount: attr.occurrencesCount || 0,
            invoiceId: nextProps.invoiceId || null,
            endingType: attr.endingType || 'never',
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event.preventDefault()
        let data = {
            occurrencesCount: parseInt(this.state.occurrencesCount),
            startDate: this.formatDateOnly(this.state.startDate),
            endingType: this.state.endingType,
        }
        if (this.state.endDate) {
            data.endDate = this.formatDateOnly(this.state.endDate)
        }
        AppContext.getApiClient().patch('/invoices/' + this.state.invoiceId, {
            recurringInfo: data,
        }).then((r) => {
            this.state.onChange(r.attributes.recurringInfo)
            this.setState({
                info: r.attributes.recurringInfo,
                editMode: false,
            })
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    renderText() {
        const info = this.state.info || {}
        const attr = info.attributes || {}
        let end = <EndingTypeLabel endingType={'never'} />
        switch (attr.endingType) {
            case 'by':
                end = <FormattedMessage
                    id="invoice.recurring.schedule.never_ends"
                    defaultMessage="Ends on {date}"
                    values={{
                        date: <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={attr.endDate} />
                    }}
                />
                break
            case 'after':
                end = <FormattedMessage
                    id="invoice.recurring.schedule.ends_after_nb_occurrences"
                    defaultMessage="{count, plural, one {Ends after # occurrence} other {Ends after # occurrences}} "
                    values={{
                        count: attr.occurrencesCount
                    }}
                />
                break
        }

        return <span>
            <FormattedMessage
                id="invoice.recurring.schedule.start_on"
                defaultMessage="Starts on {date}"
                values={{
                    date: <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={attr.startDate} />
                }}
            />
            &nbsp;/&nbsp;
            {end}
        </span>
    }

    formatDateOnly(momentDate) {
        const newDate = momentDate.toDate()
        newDate.setHours(0, 0, 0, 0)
        return newDate.toISOString()
    }

    startingToday(day) {
        return !isInclusivelyAfterDay(day, moment())
    }

    renderInput() {
        let end = ''
        switch (this.state.endingType) {
            case 'by':
                end = <SingleDatePicker
                    small
                    focused={this.state.endDateFocused}
                    displayFormat="LL"
                    onDateChange={(date) => {
                        this.setState({
                            endDate: date
                        })
                    }}
                    isOutsideRange={day => this.startingToday(day)}
                    onFocusChange={({ focused }) => this.setState({ endDateFocused: focused })}
                    date={this.state.endDate}
                    numberOfMonths={1}
                    id={'endDate'}
                />
                break
            case 'after':
                end = <FormattedMessage
                    id="invoice.recurring.schedule.occurrences_count"
                    defaultMessage="{count} occurrences"
                    values={{
                        count: <input
                            onFocus={this.handleFocus}
                            style={{ width: '4em' }}
                            className="form-control d-inline"
                            min={1}
                            type={'number'}
                            value={this.state.occurrencesCount}
                            onChange={this.handleFormChange}
                            name={'occurrencesCount'}
                        />
                    }}
                />
                break
        }


        const endingTypes = ['never', 'by', 'after']
        return <span>
            <FormattedMessage
                id="invoice.recurring.schedule.start_on"
                defaultMessage="Starts on {date}"
                values={{
                    date: <SingleDatePicker
                        small
                        isOutsideRange={day => this.startingToday(day)}
                        focused={this.state.startDateFocused}
                        displayFormat="LL"
                        onDateChange={(date) => {
                            const newDate = date.toDate()
                            newDate.setHours(0, 0, 0, 0)
                            this.setState({
                                startDate: date
                            })
                        }}
                        onFocusChange={({ focused }) => this.setState({ startDateFocused: focused })}
                        date={this.state.startDate}
                        numberOfMonths={1}
                        id={'startDate'}
                    />
                }}
            />
            &nbsp;/&nbsp;
            <span className={'mr-2'}>
                <select className="custom-select w-auto" name={'endingType'} value={this.state.endingType} onChange={this.handleFormChange}>
                    {endingTypes.map(type => <option key={type} value={type}>{LabelHelper.getEndingTypeLabel(this.props.intl, type)}</option>)}
                </select>
            </span>
            <span>{end}</span>
        </span>
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    render() {
        if (!this.state.info) {
            return ''
        }

        let text = this.renderText()

        if (this.state.editable) {

            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {text} <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
            </a>
            text = <span>
                {link}
                <div className={"dropdown-menu p-4 w-100 " + (this.state.editMode ? 'show' : '')}>
                    <div className="w-100 mb-1">
                        {this.renderInput()}
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </button>
                    </p>
                </div>
            </span>
        }

        return text
    }

}

export default injectIntl(RecurringInvoiceSchedule)





// WEBPACK FOOTER //
// ./src/invoice/recurring/schedule.component.jsx